import placeholder from "url:asset/song-placeholder.svg";
import TileFrame from "./TileFrame";

// Web port of PlaylistTileView + PlaylistTileButton
// (LibraryFeature/View/Component/Songs/).
//
// In the app, tapping a playlist navigates to its detail screen.

export interface PlaylistTileProps {
  title: string;
  subtitle: string | null;
  artworkUrls: string[];
  /** Fixed edge length, or null to fill the available width. */
  width: number | null;
  onClick: () => void;
}

/** Beyond four the tiles get too small to read, so the collage caps there. */
const MAX_COLLAGE = 4;

export default function PlaylistTile(props: PlaylistTileProps) {
  const urls = props.artworkUrls.slice(0, MAX_COLLAGE);

  return <TileFrame
    width={props.width}
    title={props.title}
    subtitle={props.subtitle}
    onClick={props.onClick}
  >
    <Collage urls={urls} />
  </TileFrame>
}

// One fills the square, two split it into full-height columns, three puts a
// full-height tile beside a stacked pair, and four is an even 2x2 — matching
// the switch in PlaylistTileView.
function Collage(props: { urls: string[] }) {
  if (props.urls.length === 0) {
    return <Cell url={placeholder} />
  }

  if (props.urls.length === 1) {
    return <Cell url={props.urls[0]} />
  }

  if (props.urls.length === 2) {
    return <div className="grid h-full w-full grid-cols-2">
      <Cell url={props.urls[0]} />
      <Cell url={props.urls[1]} />
    </div>
  }

  if (props.urls.length === 3) {
    return <div className="grid h-full w-full grid-cols-2">
      <Cell url={props.urls[0]} />
      <div className="grid grid-rows-2">
        <Cell url={props.urls[1]} />
        <Cell url={props.urls[2]} />
      </div>
    </div>
  }

  return <div className="grid h-full w-full grid-cols-2 grid-rows-2">
    {props.urls.map((url, i) => <Cell key={`${url}-${i}`} url={url} />)}
  </div>
}

// Each cell crops to fill its slot, the way object-fit: cover does. The
// min-h-0/min-w-0 keeps grid children from being sized by their content.
function Cell(props: { url: string }) {
  return <div className="min-h-0 min-w-0 overflow-hidden bg-gray-200">
    <img src={props.url} alt="" className="h-full w-full object-cover" />
  </div>
}
